
interface Period {
  years: string;
  position: string;
  focus: string;
  actions: string[];
  tags: string[];
  epochTitle: string;
  globalIndex: number;
}

interface TimelineDetailsProps {
  period: Period;
  onClose: () => void;
}

export default function TimelineDetails({ period, onClose }: TimelineDetailsProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-6">
      <div 
        className="max-w-4xl w-full max-h-[90vh] overflow-y-auto rounded-3xl shadow-2xl"
        style={{ backgroundColor: '#F5F3F0' }}
      >
        {/* Header */}
        <div 
          className="p-8 rounded-t-3xl relative"
          style={{ backgroundColor: '#E8E4E0' }}
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full transition-colors cursor-pointer"
            style={{ 
              backgroundColor: '#D4C4B0',
              color: '#5D4E37'
            }}
          >
            <i className="ri-close-line text-xl"></i>
          </button>

          <div 
            className="inline-block px-6 py-3 rounded-full text-lg font-bold mb-6"
            style={{
              backgroundColor: '#D4C4B0',
              color: '#5D4E37'
            }}
          >
            {period.years}
          </div>

          <h2 
            className="text-3xl md:text-4xl font-bold mb-4"
            style={{ color: '#5D4E37' }}
          >
            {period.position}
          </h2>

          <p 
            className="text-lg mb-4"
            style={{ color: '#6B5B4F' }}
          >
            {period.epochTitle}
          </p>

          <p 
            className="text-xl leading-relaxed"
            style={{ color: '#8B7D6B' }}
          >
            重點領域：{period.focus}
          </p>
        </div>

        {/* Content */}
        <div className="p-8">
          {/* 主要政績 */}
          <div className="mb-8">
            <h3 
              className="text-2xl font-bold mb-6"
              style={{ color: '#5D4E37' }}
            >
              主要政績與貢獻
            </h3>
            <div className="space-y-4">
              {period.actions.map((action, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl"
                  style={{ backgroundColor: '#E8E4E0' }}
                >
                  <div 
                    className="w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 mt-1"
                    style={{ backgroundColor: '#D4C4B0' }}
                  >
                    <span 
                      className="text-sm font-bold"
                      style={{ color: '#5D4E37' }}
                    >
                      {index + 1}
                    </span>
                  </div>
                  <p 
                    className="text-lg leading-relaxed"
                    style={{ color: '#6B5B4F' }}
                  >
                    {action}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* 標籤 */}
          <div className="mb-8">
            <h3 
              className="text-2xl font-bold mb-6"
              style={{ color: '#5D4E37' }}
            >
              相關領域
            </h3>
            <div className="flex flex-wrap gap-3">
              {period.tags.map((tag, index) => (
                <span
                  key={index}
                  className="px-6 py-3 rounded-full text-base font-medium"
                  style={{
                    backgroundColor: '#D4C4B0',
                    color: '#5D4E37'
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          {/* 歷史背景 */}
          <div 
            className="p-6 rounded-xl"
            style={{ backgroundColor: '#E8E4E0' }}
          >
            <h3 
              className="text-xl font-bold mb-4"
              style={{ color: '#5D4E37' }}
            >
              歷史意義
            </h3>
            <p 
              className="text-lg leading-relaxed"
              style={{ color: '#6B5B4F' }}
            >
              {period.years}年間，嚴家淦先生擔任{period.position}，
              在{period.focus}方面做出重要貢獻，為臺灣的經濟發展奠定了堅實基礎。
              這一時期的政策制定和執行，對後續的國家建設產生了深遠影響。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
